(() => {
  let accordionRefreshBound = false;
  let accordionResizeTimer = null;

  function initSwiper(selector, options) {
    if (!window.Swiper) return;
    document.querySelectorAll(selector).forEach((el) => {
      if (el.swiper) return;
      new Swiper(el, options);
    });
  }

  function initNeededSwipeHints() {
    document.querySelectorAll('[data-section="product-reviews"]').forEach((section) => {
      if (section.dataset.neededSwipeHintReady === 'true') return;
      const slider = section.querySelector('.needed_slider');
      const hint = section.querySelector('[data-needed-swipe-hint]');
      const prev = section.querySelector('[data-needed-prev]');
      const next = section.querySelector('[data-needed-next]');
      const track = section.querySelector('.needed_swipe_hint__track');
      if (!slider || !slider.swiper || !hint || !prev || !next || !track) return;
      section.dataset.neededSwipeHintReady = 'true';

      const swiper = slider.swiper;
      const setDotPosition = () => {
        const progress = Number.isFinite(swiper.progress) ? Math.min(Math.max(swiper.progress, 0), 1) : 0;
        const travel = Math.max(track.clientWidth - 6, 0);
        track.style.setProperty('--needed-swipe-dot-left', `${3 + progress * travel}px`);
      };
      const updateHint = () => {
        const canSwipe = !swiper.isLocked && swiper.slides.length > Math.ceil(swiper.params.slidesPerView || 1);
        hint.hidden = !canSwipe;
        prev.disabled = swiper.isBeginning || !canSwipe;
        next.disabled = swiper.isEnd || !canSwipe;
        setDotPosition();
      };

      prev.addEventListener('click', () => swiper.slidePrev());
      next.addEventListener('click', () => swiper.slideNext());
      swiper.on('slideChange progress reachBeginning reachEnd fromEdge resize update', updateHint);
      window.addEventListener('resize', updateHint);
      updateHint();
    });
  }

  function setAccordionHeight(accordion) {
    const panel = accordion.nextElementSibling;
    if (!panel) return;
    const isExpanded = accordion.classList.contains('active');
    panel.style.maxHeight = isExpanded ? `${panel.scrollHeight}px` : null;
    if (accordion.hasAttribute('aria-expanded')) {
      accordion.setAttribute('aria-expanded', String(isExpanded));
      panel.setAttribute('aria-hidden', String(!isExpanded));
    }
  }

  function refreshOpenAccordions(root = document) {
    root.querySelectorAll('[data-accordion-title].active').forEach(setAccordionHeight);
  }

  function scheduleAccordionRefresh(root = document) {
    requestAnimationFrame(() => {
      refreshOpenAccordions(root);
      requestAnimationFrame(() => refreshOpenAccordions(root));
    });
    window.setTimeout(() => refreshOpenAccordions(root), 120);
    window.setTimeout(() => refreshOpenAccordions(root), 450);
  }

  function bindAccordionRefreshEvents() {
    if (accordionRefreshBound) return;
    accordionRefreshBound = true;

    window.addEventListener('load', () => scheduleAccordionRefresh(document), { once: true });
    window.addEventListener('resize', () => {
      window.clearTimeout(accordionResizeTimer);
      accordionResizeTimer = window.setTimeout(() => scheduleAccordionRefresh(document), 80);
    });
    window.addEventListener('orientationchange', () => scheduleAccordionRefresh(document));

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => scheduleAccordionRefresh(document)).catch(() => {});
    }
  }

  function warmAccordionImage(image) {
    const imageReady = image.complete
      ? Promise.resolve()
      : new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });

    if ('fetchPriority' in image) image.fetchPriority = 'low';
    image.loading = 'eager';

    return imageReady.then(() => {
      if (typeof image.decode !== 'function') return;
      return image.decode().catch(() => {});
    });
  }

  function initAccordionImagePreloading(root = document) {
    root.querySelectorAll('[data-accordion-preload]').forEach((section) => {
      if (section.dataset.mijotaAccordionPreloadReady === 'true') return;
      section.dataset.mijotaAccordionPreloadReady = 'true';

      const warmImages = () => {
        if (section.dataset.mijotaAccordionPreloadStarted === 'true') return;
        section.dataset.mijotaAccordionPreloadStarted = 'true';

        const images = Array.from(section.querySelectorAll('[data-accordion-preload-image]'));
        Promise.allSettled(images.map(warmAccordionImage)).then(() => scheduleAccordionRefresh(section));
      };

      if (!('IntersectionObserver' in window)) {
        warmImages();
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        observer.disconnect();
        warmImages();
      }, { rootMargin: '300px 0px', threshold: 0 });

      observer.observe(section);
    });
  }

  function initMijotaVariantTiles() {
    document.querySelectorAll('[data-mijota-variant-tiles]').forEach((picker) => {
      if (picker.dataset.mijotaVariantTilesReady === 'true') return;
      picker.dataset.mijotaVariantTilesReady = 'true';

      const hero = picker.closest('.pdp_hero') || document;
      const priceCurrent = hero.querySelector('[data-mijota-price-current] span');
      const priceCompare = hero.querySelector('[data-mijota-price-compare] span');
      const saleLabel = hero.querySelector('[data-mijota-sale-label]');
      const hiddenVariantInput = hero.querySelector('[data-mijota-variant-id-input]');
      const bundlePrice = hero.querySelector('[data-mijota-bundle-main-price]');
      const bundleCompare = hero.querySelector('[data-mijota-bundle-main-compare]');
      const submitButton = hero.querySelector('.product-form__submit');
      const buttonText = submitButton?.querySelector('.button-text');

      const setCompareText = (element, text) => {
        if (!element) return;
        element.textContent = text || '';
        if (!text) {
          element.hidden = true;
          element.parentElement?.setAttribute('hidden', '');
        } else {
          element.hidden = false;
          element.parentElement?.removeAttribute('hidden');
        }
      };

      const setAvailableState = (available) => {
        if (submitButton) submitButton.disabled = !available;
        if (buttonText) {
          buttonText.innerHTML = available
            ? '<span class="cta-full">AJOUTER AU PANIER</span><span class="cta-short">AJOUTER</span>'
            : 'RUPTURE DE STOCK';
        }
      };

      const syncVariant = (input) => {
        if (!input) return;
        const available = input.dataset.available !== 'false';
        if (hiddenVariantInput) hiddenVariantInput.value = input.value;
        if (priceCurrent) priceCurrent.textContent = input.dataset.price || '';
        setCompareText(priceCompare, input.dataset.compare || '');
        if (saleLabel) {
          saleLabel.textContent = input.dataset.saving || '';
          saleLabel.hidden = !input.dataset.saving;
        }
        if (bundlePrice) bundlePrice.textContent = input.dataset.priceShort || input.dataset.price || '';
        if (bundleCompare) {
          bundleCompare.textContent = input.dataset.compareShort || '';
          bundleCompare.hidden = !input.dataset.compareShort;
        }
        setAvailableState(available);

        picker.querySelectorAll('[data-mijota-variant-card]').forEach((card) => {
          card.classList.toggle('is-selected', card.contains(input));
        });
      };

      picker.addEventListener('change', (event) => {
        const input = event.target.closest('input[name="mijota-planche-variant"]');
        if (!input) return;
        syncVariant(input);
      });

      syncVariant(picker.querySelector('input[name="mijota-planche-variant"]:checked'));
    });
  }

  function initMijotaQuantitySelectors(root = document) {
    root.querySelectorAll('quantity-input.quantity_wpr').forEach((selector) => {
      if (selector.dataset.mijotaQuantityReady === 'true') return;

      const input = selector.querySelector('input[name="quantity"]');
      const minusButton = selector.querySelector('.quantity_minus');
      const plusButton = selector.querySelector('.quantity_plus');
      if (!input || !minusButton || !plusButton) return;

      selector.dataset.mijotaQuantityReady = 'true';

      const readNumber = (value, fallback) => {
        const number = Number(value);
        return Number.isFinite(number) ? number : fallback;
      };

      const getConstraints = () => {
        const min = readNumber(input.min, 1);
        const step = Math.max(readNumber(input.step, 1), 1);
        const parsedMax = input.max === '' ? null : readNumber(input.max, null);

        return { min, step, max: parsedMax };
      };

      const getValue = () => {
        const { min } = getConstraints();
        return readNumber(input.value, min);
      };

      const updateButtonStates = () => {
        const { min, max } = getConstraints();
        const value = getValue();
        minusButton.disabled = input.disabled || value <= min;
        plusButton.disabled = input.disabled || (max !== null && value >= max);
      };

      const updateQuantity = (direction) => {
        const { min, max, step } = getConstraints();
        const value = getValue();
        const nextValue = Math.min(max ?? Infinity, Math.max(min, value + step * direction));

        if (nextValue === value) {
          updateButtonStates();
          return;
        }

        input.value = String(nextValue);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateButtonStates();
      };

      minusButton.addEventListener('click', (event) => {
        event.preventDefault();
        updateQuantity(-1);
      });
      plusButton.addEventListener('click', (event) => {
        event.preventDefault();
        updateQuantity(1);
      });
      input.addEventListener('input', updateButtonStates);
      input.addEventListener('change', updateButtonStates);

      updateButtonStates();
    });
  }

  function initMijotaSections() {
    bindAccordionRefreshEvents();
    initMijotaVariantTiles();
    initMijotaQuantitySelectors();
    initAccordionImagePreloading();

    initSwiper('.infinity_slider', {
      slidesPerView: 'auto',
      loop: true,
      spaceBetween: 0,
      allowTouchMove: false,
      speed: 2000,
      autoplay: { delay: 1, enabled: true }
    });

    initSwiper('.people_slider', {
      slidesPerView: 4,
      spaceBetween: 16,
      loop: true,
      navigation: { nextEl: '.swiper-button-next.people_arrow', prevEl: '.swiper-button-prev.people_arrow' },
      breakpoints: { 0: { slidesPerView: 1.53, centeredSlides: true }, 476: { slidesPerView: 2, centeredSlides: true }, 768: { slidesPerView: 3 }, 992: { slidesPerView: 4 } }
    });

    initSwiper('.needed_slider', {
      slidesPerView: 3,
      spaceBetween: 16,
      slidesOffsetAfter: 16,
      breakpoints: { 0: { slidesPerView: 1.39 }, 476: { slidesPerView: 2 }, 768: { slidesPerView: 3 } }
    });
    initNeededSwipeHints();

    initSwiper('.rated_slider', {
      slidesPerView: 3,
      spaceBetween: 16,
      navigation: { nextEl: '.swiper-button-next.rated_arrow', prevEl: '.swiper-button-prev.rated_arrow' },
      pagination: { el: '.swiper-pagination.rated_pagination' },
      breakpoints: { 0: { slidesPerView: 1.42 }, 476: { slidesPerView: 2.3 }, 768: { slidesPerView: 3 } }
    });

    document.querySelectorAll('.pdp_hero').forEach((section) => {
      const thumbs = section.querySelector('.pdp_thumbslider');
      const main = section.querySelector('.pdp_main_slider');
      if (!window.Swiper || !thumbs || !main || main.swiper) return;
      const thumbSlider = new Swiper(thumbs, { spaceBetween: 5, slidesPerView: 5, watchSlidesProgress: true });
      const mainSlider = new Swiper(main, {
        loop: false,
        spaceBetween: 0,
        slidesPerView: 1,
        centeredSlides: false,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        pagination: { el: section.querySelector('.pdp_slider_pagination'), clickable: true },
        navigation: { nextEl: section.querySelector('.swiper-button-next.pdp_arrow'), prevEl: section.querySelector('.swiper-button-prev.pdp_arrow') },
        thumbs: { swiper: thumbSlider }
      });
      window.addEventListener('load', () => mainSlider.update(), { once: true });
    });

    document.querySelectorAll('[data-accordion]').forEach((group) => {
      if (group.dataset.mijotaAccordionReady === 'true') return;
      group.dataset.mijotaAccordionReady = 'true';
      const accordions = group.querySelectorAll('[data-accordion-title]');
      accordions.forEach((accordion) => {
        const panel = accordion.nextElementSibling;
        if (!panel) return;

        if ('ResizeObserver' in window && panel.dataset.mijotaAccordionResizeReady !== 'true') {
          panel.dataset.mijotaAccordionResizeReady = 'true';
          const resizeObserver = new ResizeObserver(() => {
            if (!accordion.classList.contains('active')) return;
            requestAnimationFrame(() => setAccordionHeight(accordion));
          });
          Array.from(panel.children).forEach((child) => resizeObserver.observe(child));
        }

        setAccordionHeight(accordion);
        if (accordion.classList.contains('active')) {
          scheduleAccordionRefresh(group.parentNode || document);
        }
        accordion.addEventListener('click', () => {
          const isActive = accordion.classList.contains('active');
          const accordionScope = group.parentNode || group;
          accordionScope.querySelectorAll('[data-accordion-title]').forEach((item) => {
            item.classList.remove('active');
            setAccordionHeight(item);
          });
          if (!isActive) {
            accordion.classList.add('active');
            setAccordionHeight(accordion);
            scheduleAccordionRefresh(accordionScope);
          }
        });
      });
    });

    document.querySelectorAll('ul.tabs li').forEach((tab) => {
      if (tab.dataset.mijotaTabsReady === 'true') return;
      tab.dataset.mijotaTabsReady = 'true';
      tab.addEventListener('click', function () {
        const tabId = this.getAttribute('data-tab');
        const parent = this.closest('.has_parent');
        if (!parent) return;
        parent.querySelectorAll('.tab_content_img, ul.tabs li, .tab_content').forEach((el) => el.classList.remove('current'));
        this.classList.add('current');
        parent.querySelector('#' + CSS.escape(tabId))?.classList.add('current');
        parent.querySelector('.tab_content_img[data-image-id="' + CSS.escape(tabId) + '"]')?.classList.add('current');
      });
    });

    document.querySelectorAll('.comparison_section').forEach((table) => {
      if (table.dataset.mijotaComparisonReady === 'true') return;
      table.dataset.mijotaComparisonReady = 'true';
      const scroll = table.querySelector('.comparison_wpr');
      const arrows = table.querySelector('.arrows');
      const btnLeft = table.querySelector('.prev');
      const btnRight = table.querySelector('.next');
      if (!scroll || !arrows || !btnLeft || !btnRight) return;
      const getScrollBehavior = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      btnLeft.addEventListener('click', () => scroll.scrollBy({ left: -200, behavior: getScrollBehavior() }));
      btnRight.addEventListener('click', () => scroll.scrollBy({ left: 200, behavior: getScrollBehavior() }));
      let isDragging = false;
      let isHorizontalDrag = false;
      let startX = 0;
      let startY = 0;
      let startLeft = 0;
      const canSwipe = () => scroll.scrollWidth > scroll.clientWidth + 2;
      const stopSwipe = (event) => {
        if (!isDragging) return;
        isDragging = false;
        isHorizontalDrag = false;
        scroll.classList.remove('is-dragging');
        if (event?.pointerId !== undefined) scroll.releasePointerCapture?.(event.pointerId);
        check();
      };
      scroll.addEventListener('pointerdown', (event) => {
        if (!canSwipe()) return;
        if (event.pointerType === 'touch') return;
        isDragging = true;
        isHorizontalDrag = false;
        startX = event.clientX;
        startY = event.clientY;
        startLeft = scroll.scrollLeft;
        scroll.setPointerCapture?.(event.pointerId);
      });
      scroll.addEventListener('pointermove', (event) => {
        if (!isDragging) return;
        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;
        if (!isHorizontalDrag && Math.abs(deltaX) < 6) return;
        if (Math.abs(deltaX) > Math.abs(deltaY)) {
          isHorizontalDrag = true;
          scroll.classList.add('is-dragging');
          event.preventDefault();
          scroll.scrollLeft = startLeft - deltaX;
        } else if (Math.abs(deltaY) > 10) {
          stopSwipe(event);
        }
      }, { passive: false });
      scroll.addEventListener('pointerup', stopSwipe);
      scroll.addEventListener('pointercancel', stopSwipe);
      scroll.addEventListener('pointerleave', stopSwipe);
      const check = () => {
        arrows.style.display = scroll.scrollWidth > scroll.clientWidth ? 'flex' : 'none';
        btnLeft.style.opacity = scroll.scrollLeft <= 0 ? 0.5 : 1;
        btnRight.style.opacity = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth ? 0.5 : 1;
      };
      check();
      window.addEventListener('resize', check);
      scroll.addEventListener('scroll', check);
    });

    document.querySelectorAll('.people_video').forEach((wrapper) => {
      if (wrapper.dataset.mijotaVideoReady === 'true') return;
      wrapper.dataset.mijotaVideoReady = 'true';
      const video = wrapper.querySelector('video');
      const playBtn = wrapper.querySelector('.play_icon');
      if (!video || !playBtn) return;
      const updateUI = () => {
        video.classList.toggle('is-playing', !video.paused);
        video.classList.toggle('is-paused', video.paused);
      };
      const toggle = () => { video.paused ? video.play() : video.pause(); updateUI(); };
      playBtn.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
      video.addEventListener('pause', updateUI);
      video.addEventListener('play', updateUI);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMijotaSections);
  } else {
    initMijotaSections();
  }
  document.addEventListener('shopify:section:load', initMijotaSections);
})();
